const httpAgent = require("superagent-promise")(require("superagent"), Promise);

function paramsAsString(params) {
  if (!params) {
    return "";
  }

  return Object.keys(params)
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
    .join("&");
}

function promise(req) {
  return new Promise((resolve, reject) => req.end((err, res) => (err ? reject(err.response) : resolve(res))));
}

class Api {
  constructor({ app, agent, url, normalize = false, onError } = {}) {
    const apiHost = app ? "" : url || process.env.REACT_APP_API_HOST || "https://api.kitchenadvisor.de";
    const agentFinal = agent || httpAgent;

    const token = (typeof window !== "undefined" && window.localStorage.getItem("token")) || null;

    this.state = { client: this, agent: agentFinal, apiHost, app, url, token };

    this.onError = onError || (() => null);
  }

  get(endpoint, params) {
    const url = this.fullUrl({ url: `/${endpoint}`, params });

    return promise(this.state.agent.get(url))
      .then(res => res.body.data)
      .catch(res => {
        this.onError(res);
        if (res) {
          const error = { status: res.status, error: res.body && res.body.error };
          throw error;
        }
      });
  }

  getRaw(endpoint, params) {
    const url = this.fullUrl({ url: `/${endpoint}`, params });

    return promise(this.state.agent.get(url))
      .then(res => res.body)
      .catch(res => {
        this.onError(res);
        if (res) {
          const error = { status: res.status, error: res.body && res.body.error };
          throw error;
        }
      });
  }

  post(endpoint, data) {
    const url = this.fullUrl({ url: `/${endpoint}` });

    return promise(this.state.agent.post(url).send({ data }))
      .then(res => res.body.data)
      .catch(res => {
        this.onError(res);
        if (res) {
          const error = { status: res.status, error: res.body && res.body.error };
          throw error;
        }
      });
  }

  postFormData(endpoint, formData) {
    const url = this.fullUrl({ url: `/${endpoint}` });

    return promise(this.state.agent.post(url).send(formData))
      .then(res => res.body.data)
      .catch(res => {
        this.onError(res);
        if (res) {
          const error = { status: res.status, error: res.body && res.body.error };
          throw error;
        }
      });
  }

  // del(url) {
  //   return promise(this.state.agent.del(url)).then(res => res.body);
  // }

  // put(url, data) {
  //   return promise(this.state.agent.put(url).send({ data })).then(res => res.body);
  // }

  fullUrl({ url, params }) {
    const { token, apiHost } = this.state;
    const paramsWithToken = Object.assign({}, params, { access_token: token });

    return `${((apiHost && apiHost) || "") + url}?${paramsAsString(paramsWithToken)}`;
  }

  setToken(token) {
    this.state.token = token;
    window.localStorage.setItem("token", token);
  }
}

export default Api;
